<mat-icon *ngIf="data[fieldName]" svgIcon="flag" class="flag"></mat-icon>
